import React from "react";
import useAuthStore from "../../stores/useAuthStore";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function ButtonLogout() {
  const signOut = useAuthStore((state) => state.signOut);

  const userIcons = (role) => {
    switch (role) {
      case "Teacher":
        return "graduation-cap";
      case "Student":
        return "user";
      case "Superuser":
        return "user-ninja";
      case "Admin":
        return "user-plus";
      default:
        return "user";
    }
  };

  var role = localStorage.getItem("role") ? localStorage.getItem("role") : "";
  var email = localStorage.getItem("email");

  return (
    <div className="logout--button-container">
      <div className="logout--button" onClick={signOut}>
        <p className="logout--text">
          <FormattedMessage id="LogOut" />
        </p>
      </div>
      <div className="logout--icon-container">
        <FontAwesomeIcon icon={userIcons(role)} />
      </div>
      <div className="logout--email-container">
        <span>{email}</span>
      </div>
    </div>
  );
}

export default ButtonLogout;
